import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Menu,
  ScrollArea,
  Select,
  Text,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useHotkeys, useMediaQuery } from "@mantine/hooks";
import {
  IconArrowRight,
  IconBrandBootstrap,
  IconClipboardList,
  IconEyeSearch,
  IconFileExport,
  IconFileTypography,
  IconRocket,
  IconSearch,
  IconTimeDuration15,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import * as xlsx from "xlsx";

import { useNavigate } from "react-router";
import {
  keySearchRequestInventoryTransaction,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  getMasterOrgSelect,
  getTblInventoryTransactionTypeOutWard,
} from "../../../../service/getSelectApi";

import { modals } from "@mantine/modals";
import { useSearchParams } from "react-router-dom";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import { AvatarUtils } from "../../../../common/ColorByName/AvatarUtils";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import InputSearch from "../../../../common/InputSearch/InputSearch";
import { green, teal } from "../../../../const/variables";
import { TblRequestInventoryTransactionList } from "../../../../model/TblRequestInventoryTransaction";
import SuggestItemWardModal from "../components/SuggestItemWardModal";

const RequestOutWardTransaction = () => {
  const isSmallScreen605 = useMediaQuery("(max-width: 605px)");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get("Type");
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  // Reference data from another table
  const [branchAll, setBranchAll] = useState<SelectListItemBase[]>([]);
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblRequestInventoryTransactionList[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [dataInventoryTransactionType, setDataInventoryTransactionType] =
    useState<ComboboxItem[]>([]);
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);

  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const sizeGrid = { base: 12, sm: 3, md: 3, lg: 2 };

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const buildDefaultFromDate = () =>
    new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() - 14)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    ).toISOString();
  const buildDefaultToDate = () =>
    new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    ).toISOString();

  // Initialize form state from localStorage
  const innitStateSearch = useMemo(() => {
    const savedSearch = localStorage.getItem(
      keySearchRequestInventoryTransaction,
    );
    if (savedSearch && checkedPinSearch) {
      try {
        const parsed = JSON.parse(savedSearch);
        return {
          keySearch: parsed.KeySearch ?? "",
          fromDate: parsed.FromDate ?? buildDefaultFromDate(),
          toDate: parsed.ToDate ?? buildDefaultToDate(),
          sourceType: parsed.SourceType ?? "",
          shipingVendor: parsed.ShipingVendor ?? "",
          branchId: parsed.BranchId ?? "",
          // store as string so Select matches option values ("true")
          IsEcommerce:
            parsed.IsEcommerce != null ? String(parsed.IsEcommerce) : undefined,
        };
      } catch (error) {
        console.error("Error parsing saved search:", error);
      }
    }
    return {
      keySearch: "",
      fromDate: buildDefaultFromDate(),
      toDate: buildDefaultToDate(),
      sourceType: "",
      shipingVendor: "",
      // branchId: String(
      //   JSON.parse(localStorage.getItem("userLoginHeader") || "{}")?.branchId ||
      //     "",
      // ),
      branchId: "",
      IsEcommerce: undefined,
    };
  }, []);

  const form = useForm({
    initialValues: innitStateSearch,
  });

  const fetchDataGetAll = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<SelectListItemBase[]>
      >(`/api/v1/TblDmInventory/get-select-branch?auth=false`);

      if (response && response.success) {
        const result = response.data;
        setBranchAll(result);
      } else {
        console.error("Failed to fetch departmentFund details");
      }
    } catch (error) {
      console.error("Error fetching departmentFund details", error);
    }
  };

  useEffect(() => {
    fetchDataGetAll();
  }, []);
  const breadcrumbs = React.useMemo(
    () => [
      {
        link: "/",
        title: "Trang chủ",
      },
      {
        title: "Cấu hình kho hàng",
      },
      {
        title: "Danh sách đơn cần xuất",
      },
    ],
    [],
  );

  const items = React.useMemo(
    () =>
      breadcrumbs?.map((item, index) =>
        index === 0 ? (
          <Anchor href={item.link} key={index}>
            {item.title}
          </Anchor>
        ) : (
          <p key={index}>{item.title}</p>
        ),
      ),
    [breadcrumbs],
  );

  const columns = React.useMemo<
    MRT_ColumnDef<TblRequestInventoryTransactionList>[]
  >(
    () => [
      {
        accessorKey: "index",
        header: "STT",
        size: 30,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row: { index } }: any) => index + 1,
      },
      {
        accessorKey: "sourceTranCode",
        header: "Mã yêu cầu xuất kho",
        Cell: ({ renderedCellValue, row }: any) =>
          String(row.original.shippingPriority) === "1" ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                size="lg"
                style={{ cursor: "pointer" }}
                leftSection={<IconRocket size={16} />}
                color={"red"}
                onDoubleClick={() =>
                  handleDetailRequest(
                    row.original.sourceType,
                    row.original.sourceTranCode,
                  )
                }
              >
                {renderedCellValue === null
                  ? "Không tồn tại"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="lg"
                style={{ cursor: "pointer" }}
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={() =>
                  handleDetailRequest(
                    row.original.sourceType,
                    row.original.sourceTranCode,
                  )
                }
              >
                {renderedCellValue === null
                  ? "Không tồn tại"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ),
      },
      {
        accessorKey: "createDate",
        header: "Thời gian tạo",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "finishDate",
        header: "Thời gian hoàn thành",
        size: 170,
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "sourceTypeName",
        header: "Lý do",
        Cell: ({ row, renderedCellValue }) => (
          <Badge
            color={getColorType(row.original.sourceType ?? null)}
            variant="light"
            bd={`1px solid ${getColorType(row.original.sourceType ?? null)}`}
          >
            {renderedCellValue}
          </Badge>
        ),
        size: 250,
      },
      {
        accessorKey: "branchId",
        header: "Chi nhánh",
        Cell: ({ row, renderedCellValue }) =>
          branchAll.find((x) => String(x.value) === String(renderedCellValue))
            ?.text ?? "Không xác định",
        size: 250,
      },
      {
        accessorKey: "depName",
        header: "Phòng ban",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={700} size="sm">
            {renderedCellValue}
          </Text>
        ),
        size: 250,
      },
      {
        accessorKey: "workAddress",
        header: "Địa điểm làm việc",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={700} size="sm">
            {renderedCellValue}
          </Text>
        ),
        size: 275,
      },
      {
        accessorKey: "roleName",
        header: "Chức danh",
        Cell: ({ renderedCellValue }) => (
          <Text size="11.5px">{renderedCellValue}</Text>
        ),
        size: 250,
      },
      {
        accessorKey: "empName",
        header: "Họ & Tên",
        size: 250,
        Cell: ({ renderedCellValue, cell, row }: any) =>
          row.original.empName ? (
            <Flex align="center">
              <AvatarUtils value={row.original.empName?.split("-")[1]} /> -
              <Text fw={600}>{row.original.empName?.split("-")[0]}</Text>
            </Flex>
          ) : (
            <Text size="sm">Không xác định</Text>
          ),
      },

      {
        accessorKey: "note",
        header: "Ghi chú",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue}>
            <Text size="sm" maw={300}>
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "a",
        header: "GHNN",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue}>
            <Text size="sm" maw={300}>
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "attribute1",
        header: "Id TMĐT",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue}>
            <Text size="sm" maw={300}>
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableResizing: false,
        size: 100,
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Tạo phiếu">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={async () => {
                  createData(
                    row.original.sourceTranCode,
                    row.original.sourceType,
                  );
                }}
              >
                <IconArrowRight size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Sản phẩm đề xuất">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="violet"
                onClick={async () => {
                  openSuggestModal(
                    row?.original?.sourceTranCode ?? "",
                    row?.original?.sourceType ?? "",
                  );
                }}
              >
                <IconEyeSearch size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [branchAll],
  );

  const componentSearch = () => {
    return (
      <Grid mt={"10px"}>
        <Grid.Col span={sizeGrid}>
          <InputSearch
            placeholder="Từ khoá"
            onSearch={fetchData}
            value={form.values.keySearch}
            // onChange={(value) => {
            //   form.setFieldValue("keySearch", value);
            // }}
            {...form.getInputProps("keySearch")}
          />
        </Grid.Col>

        <Grid.Col span={sizeGrid}>
          <Select
            placeholder={"Loại chứng từ gốc"}
            searchable
            clearable
            {...form.getInputProps("sourceType")}
            leftSection={<IconFileTypography color="#15aabf" />}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            data={dataInventoryTransactionType}
            nothingFoundMessage={"Không có dữ liệu"}
            onClick={() => {
              if (dataInventoryTransactionType.length === 0) {
                fetchdataInventoryTransactionType();
              }
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            size="sm"
            placeholder="Chọn ngày bắt đầu"
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              form.values.fromDate && form.values.fromDate.length > 0
                ? new Date(form.values.fromDate)
                : null
            }
            onChange={(e) => {
              form.setFieldValue("fromDate", formatDateNotTimeZone(e) ?? "");
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            size="sm"
            placeholder="Chọn ngày kết thúc"
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              form.values.toDate && form.values.toDate.length > 0
                ? new Date(form.values.toDate)
                : null
            }
            onChange={(e) => {
              form.setFieldValue("toDate", formatDateNotTimeZone(e) ?? "");
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder={"Đơn vị giao vận"}
            searchable
            clearable
            {...form.getInputProps("shipingVendor")}
            leftSection={<IconArrowRight color="#15aabf" />}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            data={[
              { value: "Ahamove", label: "Ahamove" },
              { value: "Giao hàng tiết kiệm", label: "Giao hàng tiết kiệm" },
            ]}
            nothingFoundMessage={"Không có dữ liệu"}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Nhập mã hoặc tên chi nhánh"
            data={dataBranchSelect}
            searchable
            clearable
            {...form.getInputProps("branchId")}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            nothingFoundMessage="Không tìm thấy dữ liệu !"
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Loại đơn hàng"
            leftSection={<IconClipboardList color="#15aabf" />}
            data={[{ label: "Đơn hàng TMĐT", value: "true" }]}
            clearable
            {...form.getInputProps("IsEcommerce")}
          />
        </Grid.Col>
        {!isSmallScreen605 && (
          <Grid.Col span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        )}
      </Grid>
    );
  };

  const handleExport = () => {
    try {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
      xlsx.writeFile(workbook, "danh-sach-phieu-xuat-kho.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  const createData = (
    sourceCode?: string | null,
    sourceType?: string | null,
  ) => {
    if (sourceCode) {
      navigate("/warehouse-config/create-warehouse-out-ward", {
        state: { sourceCode: sourceCode, sourceType: sourceType },
      });
    } else {
      navigate("/warehouse-config/create-warehouse-out-ward");
    }
  };

  //   const editData = (id: string | number) => {
  //     navigate("/warehouse-config/edit-warehouse-out-ward", {
  //       state: { id: id },
  //     });
  //   };

  useHotkeys([
    [
      "F11",
      () => {
        createData();
      },
    ],
  ]);

  const handleDetailRequest = (sourceType: string, sourceCode: string) => {
    switch (sourceType) {
      case "XUAT_BAN":
        detailOrder(sourceCode);
        break;
      default:
        detailRequestTransfer(sourceCode);
        break;
    }
  };

  const getColorType = (type: string | null) => {
    switch (type) {
      case "XUAT_DIEU_CHUYEN_CHI_NHANH":
        return "#f06418";
      case "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return "#ffab09";
      case "XUAT_HUY":
        return "#d9d02f";
      case "XUAT_DIEU_CHINH":
        return "#6bd731";
      case "XUAT_DIEU_CHUYEN_NOI_BO":
        return "#09b8ff";
      case "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL":
        return "#1f32c4";
      case "XUAT_TRA_NCC":
        return "#2bdd66";
      case "XUAT_BAN":
        return teal.light;
      case null:
        return "rgba(0, 0, 0, 0)";
      case "NOI_BO":
        return "#656a7e";
    }
  };

  const openSuggestModal = (sourceCode: string, sourceType: string) => {
    try {
      modals.openConfirmModal({
        title: (
          <>
            <Title order={5}>Danh sách sản phẩm!</Title>
          </>
        ),
        radius: "md",
        size: "auto",
        children: (
          <SuggestItemWardModal
            sourceType={sourceType}
            sourceCode={sourceCode}
          />
        ),
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
      });
    } catch (error) {
      console.error(error);
      return;
    }
  };

  // Detail:
  const detailOrder = async (sourceCode: string) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${sourceCode}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    const data = response?.data;

    if (response && response.success) {
      const isReturnOrder = sourceCode.includes("DT");
      navigate(isReturnOrder ? "/sell/return-order" : "/sell/view-order", {
        state: {
          id: data?.orderHeader.id,
          orderNumber: data?.orderHeader.orderNumber,
          orderType: data?.orderHeader.orderTypeId.toString(),
          actionType: "view",
          ...(isReturnOrder && { action: "tra" }),
        },
      });
    }
  };

  const detailRequestTransfer = (sourceCode: string) => {
    navigate("/warehouse-config/detail-request-transfer", {
      state: { sourceCode: sourceCode },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    const formValues = form.getValues();

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }&Type=${2}`;

    if (formValues.keySearch) {
      url += `&KeySearch=${formValues.keySearch}`;
    }

    if (formValues.sourceType) {
      url += `&SourceType=${formValues.sourceType}`;
    }

    if (formValues.fromDate) {
      url += `&FromDate=${formValues.fromDate}`;
    }
    if (formValues.toDate) {
      url += `&ToDate=${formValues.toDate}`;
    }

    if (formValues.shipingVendor) {
      url += `&ShipingVendor=${formValues.shipingVendor}`;
    }

    if (formValues.branchId) {
      url += `&BranchId=${formValues.branchId}`;
    }
    // Chỉ truyền IsEcommerce=true khi user chọn "Đơn hàng TMĐT"
    if (formValues.IsEcommerce && String(formValues.IsEcommerce) === "true") {
      url += `&IsEcommerce=true`;
    }
    let _softing = "";
    let isOrder = false;
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) {
        _softing = _q.id;
        isOrder = _q.desc;
      }
      url = url + "&sort=" + _softing + "&isOrder=" + isOrder;
    }

    try {
      const response = await repositoryPos.get<
        MessageResponse<TblRequestInventoryTransactionList[]>
      >(
        `/api/v1/RequestInventoryTransaction/get-list-request-transaction-out-ward${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setIsLoading(false);
        setData(result || []);
        setRowCount(response.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setData([]);
        setRowCount(0);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsRefetching(false);
      setIsLoading(false);
      try {
        const saveObj: any = {
          Skip: pagination.pageIndex * pagination.pageSize,
          Take: pagination.pageSize,
          KeySearch: formValues.keySearch ?? "",
          FromDate: formValues.fromDate ?? "",
          ToDate: formValues.toDate ?? "",
          SourceType: formValues.sourceType ?? "",
          ShipingVendor: formValues.shipingVendor ?? "",
          BranchId: formValues.branchId ?? "",
        };

        // Chỉ lưu IsEcommerce khi user đã chọn "Đơn hàng TMĐT"
        if (
          formValues.IsEcommerce &&
          String(formValues.IsEcommerce) === "true"
        ) {
          saveObj.IsEcommerce = true;
        }

        localStorage.setItem(
          keySearchRequestInventoryTransaction,
          JSON.stringify(saveObj),
        );
      } catch (e) {
        /* ignore localStorage errors */
      }
    }
  };

  const fetchdataInventoryTransactionType = async () => {
    const response: SelectListItemBase[] =
      await getTblInventoryTransactionTypeOutWard();

    setDataInventoryTransactionType(
      response.map((type) => ({
        value: type.value.toString(),
        label: type.text,
      })),
    );
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();
    setDataBranchSelect(
      res
        ?.filter(
          (item) =>
            item.text != null && item.value != null && item.value !== "-1",
        )
        ?.map((item) => ({
          value: item.value?.toString(),
          label: `${item.att1} - ${item.text}`,
        })),
    );
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [sorting, pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    getDataBranchSelect();
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    // enableRowSelection: true,
    // getRowId: (row) => row.transactionId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["index", "sourceTranCode", "mrt-row-select"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: {
        maxHeight: isSmallScreen605 ? 500 : height,
        minHeight: isSmallScreen605 ? 500 : height,
      },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: true,
    enableColumnActions: false,
    rowCount,
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style:
        String(row.original.shippingPriority) === "1"
          ? {
              fontWeight: "500",
              fontSize: "12.5px",
              padding: "5px 12px",
              color: "red",
            }
          : {
              fontWeight: "500",
              fontSize: "12.5px",
              padding: "5px 12px",
            },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      sorting,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: !isSmallScreen605 ? true : false,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: !isSmallScreen605 ? "pages" : "default",
    enableColumnPinning: !isSmallScreen605 ? true : false,
    mantineTableProps: {
      striped: false,
    },
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "5px" }}
        ref={headerRef}
      >
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            w={isSmallScreen605 ? "100%" : 130}
            onClick={handleExport}
          >
            Export Excel
          </Button>
        </Flex>

        {!isSmallScreen605 ? (
          componentSearch()
        ) : (
          <Menu width={"target"}>
            <Menu.Target>
              <Button leftSection={<IconSearch size={16} />} mt={10} w={"100%"}>
                Bộ lọc tìm kiếm
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Box h={420}>
                <ScrollArea h={380}>{componentSearch()}</ScrollArea>
                <Flex justify={"center"} align={"center"} gap={"xs"}>
                  <Button
                    leftSection={<IconSearch size={14} />}
                    color="blue"
                    variant="outline"
                    onClick={async () => {
                      await fetchData();
                    }}
                  >
                    Tìm kiếm
                  </Button>
                </Flex>
              </Box>
            </Menu.Dropdown>
          </Menu>
        )}
      </div>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default RequestOutWardTransaction;
